import React from 'react';
import PropTypes from 'prop-types';

import createStyle from 'shared-utils/src/createStyle';

import GridItem from '../../../GridItem';

import style, { mainCls } from './style';

const useStyles = createStyle(style);

const PrivacyLink = ({ portalDomain }) => {

  const cls = useStyles();

  return (
    <GridItem behavior="fixed" className="pt--ml pb--ml">
      <p className={`${cls[`${mainCls}__info`]} tp-s--s c-txt--f2`}>
        Ho letto l'informativa sul <a target="_blank" noopener nofererrer href={`${portalDomain}/casait/privacy/`} title="" className="c-txt--f2 tp--u">trattamento dei dati personali</a>.
      </p>
    </GridItem>
  );
};

export default PrivacyLink;

PrivacyLink.propTypes = {
  portalDomain: PropTypes.string,
};

PrivacyLink.defaultProp = {
  portalDomain: 'https://www.casa.it',
};
